import { apiFetch } from './api';

/**
 * Feuille de présence vue par la personne qui détient le jeton : la séance,
 * ses journées, et l'état de SA signature. Aucune authentification — le
 * jeton fait foi, comme pour la signature du devis.
 */
export function getEmargement(token) {
  return apiFetch(`/emargement/${token}`);
}

/** Notes du formateur sur la feuille : réservé au jeton du formateur. */
export function enregistrerNotesFormateur(token, notes) {
  return apiFetch(`/emargement/${token}/notes`, {
    method: 'PUT',
    body: JSON.stringify({ notes }),
  });
}

/**
 * Signe une case — une journée, matin ou après-midi (image PNG en data URL
 * tracée sur le canvas). Le nom saisi s'inscrit dans la case.
 */
export function signerJournee(token, { jour, demiJournee = 'matin', image, nom }) {
  return apiFetch(`/emargement/${token}`, {
    method: 'POST',
    body: JSON.stringify({ jour, demiJournee, image, nom }),
  });
}
